import { z } from "zod";

/** Postgres NOTIFY channel written by publishHubEvents (lib/realtime/publish.ts). */
export const HUB_EVENTS_CHANNEL = "hub_events";

export const HUB_EVENT_KINDS = ["status", "folder", "assignment"] as const;
export type HubEventKind = (typeof HUB_EVENT_KINDS)[number];

const ProtocolEpochSchema = z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER);

/** NOTIFY payload; keys are short to stay well under Postgres's 8KB payload cap. */
export const HubNotifyPayloadSchema = z.object({
  t: z.string().uuid(),
  e: z.string().uuid().nullable(),
  k: z.enum(HUB_EVENT_KINDS),
});
export type HubNotifyPayload = z.infer<typeof HubNotifyPayloadSchema>;

/** A renewal replaces the socket's signed tenant scope and capabilities. */
export const HubClientMessageSchema = z.object({
  type: z.literal("reauth"),
  epoch: ProtocolEpochSchema,
  ticket: z.string().min(1),
});
export type HubClientMessage = z.infer<typeof HubClientMessageSchema>;

/** Messages the realtime service sends to a browser socket. */
export const HubSocketMessageSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("event"),
    tenantId: z.string().uuid(),
    endUserId: z.string().uuid().nullable(),
    kind: z.enum(HUB_EVENT_KINDS),
  }),
  z.object({ type: z.literal("resync") }),
]);
export type HubSocketMessage = z.infer<typeof HubSocketMessageSchema>;

export function toHubSocketMessage(payload: HubNotifyPayload): HubSocketMessage {
  return { type: "event", tenantId: payload.t, endUserId: payload.e, kind: payload.k };
}
